import { useEffect } from 'react';
import { Typography } from '@diritto/common/style/typography';
import { ButtonSize } from 'constants/button';
import { GNBHeight, GNBSubMenuHeight, HeaderNavBarHeight } from 'constants/layout';
import { useAuthState } from 'contexts/AuthProvider';
import {
  BlockAccessContainer,
  BlockAccessParagraph,
  BlockAccessIcon,
  BlockAccessSignLinkButton,
} from 'ui-components/common/BlockAccess';
import { useClient } from 'ui-hooks/useClient';
import { useRequestSign } from 'ui-hooks/useRequestSign';
import { useViewPort } from 'ui-hooks/useViewPort';
import { WaveIcon } from 'icons/ritto/Wave';

export const BlockAuth = ({ message }: { message?: string }) => {
  const requestSign = useRequestSign();
  const client = useClient();
  const { height: viewportHeight } = useViewPort();
  const { isLoaded: isAuthLoaded } = useAuthState();

  // 앱이면 해당 UI 로드 되고 바로 signWebView 띄운다.
  useEffect(() => {
    if (client.isApp && isAuthLoaded) {
      requestSign();
    }
  }, [client.isApp, isAuthLoaded, requestSign]);

  if (!isAuthLoaded) {
    return null;
  }

  const containerMinHeight = Math.max(0, viewportHeight - HeaderNavBarHeight - GNBHeight - GNBSubMenuHeight - 20);

  return (
    <BlockAccessContainer minHeight={containerMinHeight}>
      <BlockAccessIcon>
        <WaveIcon />
      </BlockAccessIcon>
      <BlockAccessParagraph>
        {message?.replace(/\\n/g, '\n') || '이 페이지는 로그인한 사용자만 이용할 수 있어요.'}
      </BlockAccessParagraph>
      <BlockAccessSignLinkButton
        buttonTypography={Typography.XXXSmall}
        size={ButtonSize.Small}
        label="로그인 및 회원가입"
      />
    </BlockAccessContainer>
  );
};
